import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import "./Aconlayout.css";
import { createContext, useContext, useEffect, useState, useRef } from "react";
import { RenderMainRoutes } from "./RenderMainRoutes";
import { RenderMainMenu } from "./RenderNavigation";
import { Config, globalBaseUrl } from "../Structur/Configurations";
import {
  Button,
  message,
  Radio,
  Modal,
  ConfigProvider,
  Divider,
  Row,
  Col,
} from "antd";
import { apiLogin, NewGuid, apiForgotPassword } from "../Api/Entity";
import { GetConfigDaten } from "../Structur/Configurations";
import { ROLE_NAME, getRoleName, getRoleNames } from "./Constants";

const LayoutContext = createContext();
export const LayoutData = () => useContext(LayoutContext);

export const LayoutWrapper = () => {
  const [tokenExpiration, setTokenExpiration] = useState(
    window.sessionStorage.getItem("tokenExpiration")
  );
  const [userDaten, setUserDaten] = useState(null);
  const [aktPdfDaten, setAktPdfDaten] = useState();
  const navigate = useNavigate();
  const [apiBaseUrl, setApiBaseUrl] = useState();
  const aconMainContainer = useRef(null);
  const location = useLocation();

  async function fetchApiBaseUrl(art) {
    const configData = await GetConfigDaten(art);
    return configData;
  }

  // Alle Basisdaten setzen nur einmal setzen
  useEffect(() => {
    fetchApiBaseUrl(0).then((apiBaseUrl) => {
      setApiBaseUrl(apiBaseUrl);
      console.log(
        "YYY Aktuelle Basisdaten gesetzt sollte nur 1x sein",
        apiBaseUrl
      );
    });
  }, [apiBaseUrl]);

  useEffect(() => {
    if (apiBaseUrl)
      console.log("YYY apiBaseUrl wurde gesetzt und sollte so bleiben 1x");
  }, [apiBaseUrl]);

  const [user, setUser] = useState({
    name: "",
    isAuthenticated: false,
    bearer: "",
    accessToken: "",
    expiresIn: null,
    tokenType: "",
    refreshToken: "",
    statusOK: true, // wird true sobald nach dem Login auch die nötigen Daten einegeben wurden
    person: null,
  });

  const killBearer = () => {
    setUser((prevUser) => ({
      ...prevUser,
      bearer: "",
    }));
  };

  const SetGlobalUserStatus = (value) => {
    //   console.log("XXX Globaer Status auf ", value);
    setUser((prevUser) => ({
      ...prevUser,
      statusOK: value,
    }));
  };
  /*
  useEffect(() => {
    const getBaseUrl = async () => {
      const config = new Config();
      config.GetConfigUrl().then((url) => {
        console.log("*** Hier wird der Basispfad gesetzt",url);
        setApiBaseUrl(url);
      });
    };
    getBaseUrl();
  }, []);
*/

  const forgotPassword = async (userName) => {
    let status = await apiForgotPassword(apiBaseUrl, userName);
  };

  const login = async (userName, password) => {
    const aktRespo = { bearer: "", status: 0, expiresIn: 0 };
    let status = await apiLogin(
      apiBaseUrl,
      userName,
      password,
      setUser,
      aktRespo
    );
    switch (status) {
      case 200:
        setCookie("login", "4711", 1);
        setCookie("name", userName, 1);
        window.sessionStorage.setItem("userEmail", userName);
        // window.sessionStorage.setItem("accessToken", user.accessToken);
        // window.sessionStorage.setItem("expiresIn", user.expiresIn);
        // window.sessionStorage.setItem("tokenType", user.tokenType);
        // window.sessionStorage.setItem("refreshToken", user.refreshToken);
        // Roles immer im Zugriff in der Session
        window.sessionStorage.setItem(
          "roles",
          await getAllRoles(userName, aktRespo.bearer)
        );
        const currentTime = new Date().getTime() / 1000;
        setTokenExpiration(currentTime + aktRespo.expiresIn - 31); // 31 Sekunden früher
        window.sessionStorage.setItem(
          "tokenExpiration",
          currentTime + aktRespo.expiresIn - 31
        );
        const daten = await getOneUser(userName, aktRespo.bearer);
        setUserDaten(daten);
        break;
      case 401:
        logout();
        break;
      default:
        window.sessionStorage.removeItem("accessToken");
        window.sessionStorage.removeItem("roles");
    }
    return status;
  };

  function setCookie(name, value, daysToExpire) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + daysToExpire);
    const cookieString = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
    document.cookie = cookieString;
  }

  function getCookie(name) {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(`${name}=`)) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  }
  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
  // Überprüft eine Role
  const checkRole = (role) => {
    if (role !== null && role !== undefined && role !== "") {
      // console.log("XXX checkRole",role);
      const userRoles = (window.sessionStorage.getItem("roles") || "").split(
        ","
      );
      return userRoles.includes(role);
      //return roles.includes(role);
    } else return true;
  };

  const checkRoleId = (roleId) => {
    return checkRole(getRoleName(roleId));
  };
  const checkRoleIds = (roleIds) => {
    for (let i = 0; i < roleIds.length; i++)
      if (checkRole(getRoleName(roleIds[i]))) return true;
    return false;
  };
  const checkRoles = (roles) => {
    // Get the comma-separated string of user roles from the session
    const userRoles = (window.sessionStorage.getItem("roles") || "").split(",");
    // If roles is not null or undefined
    if (roles !== null && roles !== undefined) {
      // Check if at least one role matches
      let hasMatchingRole = roles.some((role) => {
        const roleName = String(role).trim(); // Convert role to string and then trim
        return userRoles.includes(roleName);
      });
      // Console output for debugging purposes
      //console.log("Checking roles:", roles, " in user roles:", userRoles);
      //console.log("Result: ", hasMatchingRole);
      return hasMatchingRole;
    } else {
      return true;
    }
  };

  const { isAuthenticated } = user;
  if (!isAuthenticated) {
    // Beispiel: Lesen Sie das Cookie mit dem Namen "example"
    const exampleCookieValue = getCookie("login");
    //console.log('Value of "login" cookie:', exampleCookieValue);
    //console.log("accessToken", window.sessionStorage.getItem("accessToken"));

    if (exampleCookieValue === "4711") {
      //console.log("XXX Eingeloggt OK");
      setUser((prevUser) => ({
        ...prevUser,
        name: getCookie("name"),
        isAuthenticated: true,
        bearer: window.sessionStorage.getItem("accessToken"),
      }));
    }
  }

  const getAllRoles = async (userName, bearer) => {
    const url = apiBaseUrl + "api/getRoles?name=" + userName;
    //console.log("getAllRoles", url);
    const bearer_token = `Bearer ${bearer}`;
    try {
      const config = {
        headers: {
          Authorization: bearer_token,
        },
      };
      //console.log("axios getAllRoles userName/Config", userName, config);
      const response = await axios.get(url, config);
      //console.log("axios getAllRoles Response Data:",response.status,response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) logoutLogin();
      console.error("axios getAllRoles Error:", error.message);
      throw error;
    }
  };

  const logoutLogin = (callback) => {
    logout(() => {
      console.log("logoutLogin gehe zu login ", location.pathname);
      navigate(`/login?to=${location.pathname}`);
    });
  };

  const logout = (callback) => {
    // Hier könnten asynchrone Aufgaben für den Logout durchgeführt werden
    console.log("Logout ausgelöst");
    window.sessionStorage.removeItem("accessToken");
    window.sessionStorage.removeItem("roles");
    deleteCookie("login");
    setTokenExpiration(null);
    window.sessionStorage.removeItem("tokenExpiration");
    setUser((prevUser) => ({
      ...prevUser,
      isAuthenticated: false,
      bearer: "",
      accessToken: "",
      expiresIn: "",
      tokenType: "",
      refreshToken: "",
      statusOK: true,
      person: null,
    }));
    // Nach erfolgreichem Logout rufe das Callback auf
    if (callback) {
      callback();
    } else navigate("/");
  };

  const registerUser = async (userName, password) => {
    try {
      const respo = await axios.post(
        apiBaseUrl + "register",
        { email: userName, password: password }
        //{ headers: { Authorization: `Bearer ${bearer}`} }
      );
      return respo.status;
    } catch (error) {
      return error.response.data;
      /*
      errors: {DuplicateUserName: ["Username 'admin@admin.at' is already taken."],…}
      status: 400
      title: "One or more validation errors occurred."
      */
    }
  };

  const resendConfirmationEmail = async (userName) => {
    try {
      const respo = await axios.post(
        apiBaseUrl + "resendConfirmationEmail",
        { email: userName }
        //{ headers: { Authorization: `Bearer ${bearer}`} }
      );
      return respo.status;
    } catch (error) {
      return error.response.data;
    }
  };

  const saveUserDaten = async (data, bearer) => {
    try {
      //console.log("->saveUserDaten", data);
      const respo = await axios.post(apiBaseUrl + "api/saveUserDaten", data, {
        headers: { Authorization: `Bearer ${bearer}` },
      });
      return respo;
    } catch (error) {
      if (error.response && error.response.status === 401) logout();
      console.error("Fehler bei der Anmeldung:", error);
      throw error;
    }
  };
  const deleteUserpost = async (userName, bearer) => {
    try {
      //console.log("->deleteUser", userName);
      const respo = await axios.post(
        apiBaseUrl + "api/deleteUserDaten",
        { userName: userName },
        { headers: { Authorization: `Bearer ${bearer}` } }
      );
      return respo;
    } catch (error) {
      if (error.response && error.response.status === 401) logout();
      console.error("Fehler bei der Anmeldung:", error);
      throw error;
    }
  };
  const deleteUser = async (userName, bearer) => {
    try {
      //console.log("->deleteUser", userName);
      const respo = await axios.delete(
        apiBaseUrl + "api/delUserDaten?UserName=" + userName,
        { headers: { Authorization: `Bearer ${bearer}` } }
      );
      return respo;
    } catch (error) {
      if (error.response && error.response.status === 401) logout();
      console.error("Fehler bei der Anmeldung:", error);
      throw error;
    }
  };

  const getPersonenListJson = async () => {
    const url = apiBaseUrl + "Personen/PersonenListJson";
    const bearer_token = `Bearer ${user.bearer}`;
    try {
      const config = {
        headers: {
          Authorization: bearer_token,
        },
      };
      //console.log("axios getPersonenListJson");
      const response = await axios.get(url, config);
      //console.log("axios getPersonenListJson Response Data:",response.status,response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) logout();
      console.error("axios Error getPersonenListJson:", error.message);
      throw error;
    }
  };

  const getOneUser = async (userName, bearer) => {
    //const userName = window.sessionStorage.getItem("userEmail");
    const url = apiBaseUrl + "api/getOneUser?name=" + userName;
    const bearer_token = `Bearer ${bearer}`;
    //if (apiBaseUrl!=undefined) {
    try {
      const config = {
        headers: {
          Authorization: bearer_token,
        },
      };
      //console.log("axios getOneUser userName/Config", userName, config);
      const response = await axios.get(url, config);
      //console.log("axios getOneUser Response Data:",response.status,response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) await logout();
      console.error("axios Error:", error.message);
      throw error;
    }
    // else    console.log("Kein Basispfad definiert");
  };

  useEffect(() => {
    // Überprüfe die Gültigkeitsdauer des Tokens periodisch
    const interval = setInterval(() => {
      const currentTime = new Date().getTime() / 1000; // Aktuelle Zeit in Sekunden
      //console.log("XXX ", currentTime, tokenExpiration);
      if (!tokenExpiration) return () => clearInterval(interval);
      // Überprüfe, ob das Token abgelaufen ist
      if (tokenExpiration && currentTime >= tokenExpiration) {
        //console.log("XXX refreshAccessToken");
        try {
          const daten = refreshAccessToken(
            window.sessionStorage.getItem("refreshToken")
          );
        } catch (error) {
          // Token ist abgelaufen, logout -> Home
          clearInterval(interval); // Beende die Überprüfung, da der Benutzer weitergeleitet wurde
          console.log("Logout wegen tokenExpiration");
          logout();
        }
      }
    }, 10000); // Überprüfe alle 10 Sekunde

    return () => clearInterval(interval); // Aufräumarbeiten beim Komponentenabbau
  }, [tokenExpiration]);

  // Funktion zum Aktualisieren des Access Tokens mithilfe des Refresh Tokens
  async function refreshAccessToken(refreshToken) {
    // Sende das Refresh Token an den Authentifizierungsserver, um ein neues Access Token zu erhalten
    let baseUrl = apiBaseUrl;
    if (typeof apiBaseUrl == "undefined") {
      baseUrl = await GetConfigDaten(0);
    }
    const url = baseUrl + "refresh";
    //console.log("XXX refresh url=", url);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refreshToken: refreshToken }),
      });

      if (!response.ok) {
        console.log("Fehler beim Aktualisieren des Access Tokens");
        logout();
        //throw new Error("Fehler beim Aktualisieren des Access Tokens");
      }
      const data = await response.json();
      //console.log("XXX refreshAccessToken", data);
      window.sessionStorage.setItem("accessToken", data.accessToken);
      window.sessionStorage.setItem("expiresIn", data.expiresIn);
      window.sessionStorage.setItem("refreshToken", data.refreshToken);
      const currentTime = new Date().getTime() / 1000;
      window.sessionStorage.setItem(
        "tokenExpiration",
        currentTime + data.expiresIn - 31
      );
      setTokenExpiration(currentTime + data.expiresIn - 31); // 31 Sekunden früher
      return data.access_token;
    } catch {
      logout();
    }
  }

  const getAllUsers = async (bearer) => {
    if (apiBaseUrl !== undefined) {
      const url = apiBaseUrl + "api/getAllUsers";
      const bearer_token = `Bearer ${bearer}`;
      try {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };
        //console.log("getAllUsers", url, config);
        const response = await axios.get(url, config);
        //console.log("getAllUsers Response Data:", response.data);
        return response.data;
      } catch (error) {
        if (error.response && error.response.status === 401) logout();
        console.error("Error:", error.message);
        throw error;
      }
    } else console.log("Kein Basisfad definiert ", apiBaseUrl);
  };

  const initTitleComponent = (
    <>
      <h3 style={{ margin: "1px" }}>Meine Überschrift ... Art</h3>
      {/* <RenderMenu /> */}{" "}
    </>
  );

  const initTableComponent = <div> ... deine aktuellen Tabellendaten ... </div>;
  const initSumsComponent = (
    <div> ... deine aktuellen Summenberechnung könnten hier stehen... </div>
  );

  const [titleComponent, setTitleComponent] = useState(initTitleComponent);
  const [tableComponent, setTableComponent] = useState(initTableComponent);
  const [sumsComponent, setSumsComponent] = useState(initSumsComponent);

  const fixtop = 10;

  const aktTitleComponent = (titel) => {
    setTitleComponent(titel);
  };
  const aktTableComponent = (table) => {
    setTableComponent(table);
  };
  const aktSumsComponent = (fuss) => {
    setSumsComponent(fuss);
    checkMainContainerHeight();
  };

  const test = () => {
    return "Testdaten " + fixtop;
  };
  const passWortRoules = [
    { required: true, message: "Bitte geben Sie ein Passwort ein!" },
    { min: 6, message: "Das Passwort muss mindestens 6 Zeichen lang sein!" },
    {
      pattern:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&().])[A-Za-z\d@$!%*?&().]+$/,
      message:
        "Das Passwort muss Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten!",
    },
  ];
  const userNameRules = [
    {
      required: true,
      message: "Bitte geben Sie eine E-Mail Adresse als Benutzernamen ein!",
    },
    {
      type: "email",
      message: "Bitte geben Sie eine gültige E-Mail-Adresse ein!",
    },
  ];

  const newGuid = async () => {
    return <NewGuid baseUrl={apiBaseUrl} />;
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Füge den Event-Listener für das resize-Event hinzu
    window.addEventListener("resize", handleResize);

    // Entferne den Event-Listener, wenn die Komponente unmontiert wird
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Leere Abhängigkeitsliste, um sicherzustellen, dass der Effekt nur einmal ausgeführt wird

  const doPostEmail = async (name, email, message) => {
    try {
      const respo = await axios.post(
        apiBaseUrl + "api/sendemail",
        { name: name, email: email, message: message },
        { headers: { Authorization: `Bearer ${user.bearer}` } }
      );
      return respo.status;
    } catch (error) {
      return error.response.status;
    }
  };
  const getApiBaseUrlAsync = async () => {
    let bUrl = apiBaseUrl;
    if (typeof apiBaseUrl == "undefined") {
      bUrl = await GetConfigDaten(0);
    }
    return bUrl;
  };
  const getApiBaseUrl = () => {
    return apiBaseUrl;
  };

  const [mainContainerHeight, setMainContainerHeight] = useState(
    window.innerHeight
  );
  function checkMainContainerHeight() {
    if (aconMainContainer.current) {
      const höhe = aconMainContainer.current.clientHeight;
      console.log("aconMainContainer", höhe);
      setMainContainerHeight(höhe);
    }
  }
  useEffect(() => {
    checkMainContainerHeight();
    window.addEventListener("resize", checkMainContainerHeight);
    return () => {
      window.removeEventListener("resize", checkMainContainerHeight);
    };
  }, []);

  const LinkToAuthPageOrLogin = ({ link, title, user }) =>
    user && user.isAuthenticated ? (
      <Link to={link}>{title}</Link>
    ) : (
      <Link to={`/login?to=${link}`}>{title}</Link>
    );

  return (
    <LayoutContext.Provider
      value={{
        windowWidth,
        user,
        SetGlobalUserStatus,
        userDaten,
        doPostEmail,
        newGuid,
        test,
        login,
        forgotPassword,
        logout,
        checkRole,
        checkRoles,
        checkRoleId,
        checkRoleIds,
        aktTitleComponent,
        aktTableComponent,
        aktSumsComponent,
        registerUser,
        resendConfirmationEmail,
        passWortRoules,
        userNameRules,
        saveUserDaten,
        deleteUser,
        getOneUser,
        getAllUsers,
        getAllRoles,
        getPersonenListJson,
        getApiBaseUrl,
        getApiBaseUrlAsync,
        setCookie,
        getCookie,
        apiBaseUrl,
        aktPdfDaten,
        setAktPdfDaten,
        aconMainContainer,
        mainContainerHeight,
        checkMainContainerHeight,
        LinkToAuthPageOrLogin,
        killBearer,
        logoutLogin,
      }}
    >
      <>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                defaultHoverBg: "#eee",
                paddingInlineLG: 55,
              },
            },
          }}
        >
          <div className="page">
            <div className="aconScroll">
              <div className="aconOben">
                <div className="container" style={{ width: "100%" }}>
                  <RenderMainMenu />
                </div>
              </div>
              <div className="aconMain" ref={aconMainContainer}>
                <RenderMainRoutes />
              </div>
              <div className="aconUnten">
                <div className="container">
                  {user.isAuthenticated &&
                  checkRoleIds([ROLE_NAME.SUPERADMIN]) ? (
                    <>
                      <Row align={"middle"}>
                        <Button
                          danger={true}
                          onClick={() => {
                            killBearer();
                            message.error("bearer killed - simmuliert 401");
                          }}
                          size="small"
                        >
                          Bearer
                        </Button>
                        &nbsp;
                        {sumsComponent}
                      </Row>
                    </>
                  ) : (
                    <>{sumsComponent}</>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ConfigProvider>
      </>
    </LayoutContext.Provider>
  );
};
/*
 theme={{
          components: {
            Button: {
              defaultHoverBg: "#eee",
              paddingInlineLG: 5,
            },
          },
        }}

*/
export const KillBearer = () => {
  const { killBearer } = LayoutData();

  useEffect(() => {
    killBearer();
  }, []);
  return null;
};
/*
  <Button onClick={killBearer} size="small">
                  Test
                </Button>
  */
